import 'regenerator-runtime/runtime'

import 'muicss/dist/css/mui.css'
import 'muicss/dist/js/mui'
import 'swiper/swiper.min.css'

import './styles/global.css'
import './styles/mui-overrides.css'
import './styles/headroom.css'
import './styles/custom-wysiwyg.css'
import './styles/swiper-pagination.css'
import './styles/typography.css'
import './styles/custom-google-map.css'
import './styles/vue-collapse.css'
import './styles/hero-slider.css'
import './styles/accordion-item.css'

import initVueApp from './vue-app'

document.addEventListener('DOMContentLoaded', () => {
  initVueApp()
})
